/* eslint-disable */
import {newerBuild, serviceWorkerUrl, versionUrl} from 'lib/serviceWorkerRouting';
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      // The query also avoids stale CDN worker objects; updateViaCache only affects the browser.
      const swUrl = serviceWorkerUrl(process.env.PUBLIC_URL, process.env.REACT_APP_BUILD_ID);

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA',
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

// registration.update() relit l'URL du worker en cours, ?build=<ancien> compris. Le CDN
// peut garder cette URL en cache et renvoyer indéfiniment l'ancien worker : aucune mise à
// jour n'est alors détectée. On lit donc la version en ligne par une URL jamais servie
// depuis le cache, et on enregistre le worker du nouveau build s'il diffère. Le nouveau
// worker passe par onupdatefound ci-dessous (activation immédiate puis rechargement).
function checkDeployedBuild() {
  fetch(versionUrl(process.env.PUBLIC_URL), {cache: 'no-store'})
    .then(response => (response.ok ? response.json() : null))
    .then(payload => {
      const build = newerBuild(process.env.REACT_APP_BUILD_ID, payload);
      if (build) {
        return navigator.serviceWorker.register(serviceWorkerUrl(process.env.PUBLIC_URL, build), {
          updateViaCache: 'none',
        });
      }
      return null;
    })
    .catch(() => {});
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    // updateViaCache: 'none' forces the browser to bypass its HTTP cache when
    // fetching the worker script. The server sends a long Cache-Control
    // max-age on service-worker.js (which we can't change), so without this
    // the browser would keep serving the stale worker for days and never
    // discover a new deploy.
    .register(swUrl, {updateViaCache: 'none'})
    .then(registration => {
      // The app is a SPA with no full-page navigations, so the browser rarely
      // runs its own update check. Trigger one on load and whenever the app
      // regains focus so new deploys are picked up promptly.
      registration.update();
      checkDeployedBuild();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update();
          checkDeployedBuild();
        }
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // A controller already exists, so this is a genuine update (not
              // the first visit). Reload once the new worker takes control,
              // then tell the waiting worker to activate immediately instead
              // of waiting for all tabs to close.
              console.log('New content is available; activating the updated service worker.');

              let refreshing = false;
              navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (refreshing) return;
                refreshing = true;
                window.location.reload();
              });

              (registration.waiting || installingWorker).postMessage({type: 'SKIP_WAITING'});

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: {'Service-Worker': 'script'},
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}
